const CatMap = require('src/contexts/catmap.json');

export const categoryMap = (category, key = 'key') => CatMap.find((e) => e[key] === category);
export const unknownCategories = ['Needs User Allocation'];
export const isUnknown = (category, key = 'key') => unknownCategories.includes(category);

export const categories = CatMap;
export const allCategoryNames = [...new Set(categories.map((c) => c.key))];

export const emojiForCategory = (category) => emoji_lut[category]?.primary ?? '';
export const colorForCategory = (category) => {
  category = category?.toLowerCase();
  const result = color_lut[category];
  return result ?? '#ffffff00';
};

const color_lut = Object.fromEntries(
  Object.entries({
    'Business services': '#D81C32',
    'Charitable Contributions': '#0F6A6A',
    Children: '#FFC8A0',
    Clothing: '#FFB830',
    Debt: '#FFA25A',
    Education: '#0D3C39',
    Entertainment: '#7C53FF',
    Food: '#A81B55',
    Gifts: '#5A9BFF',
    'Health & wellness': '#4AB2B3',
    Transfers: '#D4F573',
    Transportation: '#16584A',
    Insurance: '#FFF8A0',
    'Needs User Allocation': '#C6A83C',
    'Personal Care': '#BF7A47',
    Pets: '#FFD84B',
    Income: '#B7F14B',
    Lodging: '#B74BA1',
    'Travel & vacation': '#3B7A6F',
    Taxes: '#7C53FF',
    'General Merchandise': '#12908D',
    'General Services': '#8AB42E',
    Divorce: '#8B4513',
  }).map(([key, value]) => [key.toLowerCase(), value])
);

const emoji_lut = {
  'Business Services': {
    primary: '💼',
    secondary: '📊',
    tertiary: '📈',
  },
  'Charitable Contributions': {
    primary: '🎗️',
    secondary: '🤝',
    tertiary: '💖',
  },
  Children: {
    primary: '👶',
    secondary: '🍼',
    tertiary: '🎒',
  },
  Clothing: {
    primary: '👗',
    secondary: '👚',
    tertiary: '👕',
  },
  Debt: {
    primary: '💳',
    secondary: '📉',
    tertiary: '🏦',
  },
  Education: {
    primary: '📚',
    secondary: '🎓',
    tertiary: '🏫',
  },
  Entertainment: {
    primary: '🎮',
    secondary: '🎬',
    tertiary: '🎤',
  },
  Food: {
    primary: '🍔',
    secondary: '🍕',
    tertiary: '🍣',
  },
  Gifts: {
    primary: '🎁',
    secondary: '🎉',
    tertiary: '🎈',
  },
  'Health & Wellness': {
    primary: '💪',
    secondary: '🏋️',
    tertiary: '🧘',
  },
  Transfers: {
    primary: '🚫',
    secondary: '❌',
    tertiary: '⛔',
  },
  Income: {
    primary: '💰',
    secondary: '💵',
    tertiary: '💲',
  },
  Insurance: {
    primary: '🛡️',
    secondary: '🏥',
    tertiary: '📜',
  },
  Lodging: {
    primary: '🏠',
    secondary: '🏡',
    tertiary: '🏢',
  },
  'Needs User Allocation': {
    primary: '❓',
    secondary: '⚠️',
    tertiary: '🔍',
  },
  'Personal Care': {
    primary: '🧼',
    secondary: '🪒',
    tertiary: '💇',
  },
  Pets: {
    primary: '🐾',
    secondary: '🐶',
    tertiary: '🐱',
  },
  Taxes: {
    primary: '💸',
    secondary: '📑',
    tertiary: '💼',
  },
  Transportation: {
    primary: '🚗',
    secondary: '🚌',
    tertiary: '🚲',
  },
  'Travel & Vacation': {
    primary: '✈️',
    secondary: '🌍',
    tertiary: '🏝️',
  },
  Divorce: {
    primary: '💔',
    secondary: '⚖️',
    tertiary: '📄',
  },
  'General Merchandise': {
    primary: '🛍️',
    secondary: '🛒',
    tertiary: '🎁',
  },
  'General Services': {
    primary: '🛠️',
    secondary: '🔧',
    tertiary: '🔨',
  },
};
